import { render, staticRenderFns } from "./CapturaDocumentosFotoFrente.vue?vue&type=template&id=f3276ec8&scoped=true&"
import script from "./CapturaDocumentosFotoFrente.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoFrente.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoFrente.vue?vue&type=style&index=0&id=f3276ec8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3276ec8",
  null
  
)

export default component.exports